import React, { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

import { brand, title, urlAssets, urlBrand, urlEspecial, urlPortadaEspeciales } from '../../Constants'; 

//components
import PostalImg from '../common/PostalImg';
import CardHeader from '../common/CardHeader';
import BrandMail from '../common/BrandMail';

const AddForm = props => {

    const { idPostal } = props;

    const maxChars = 200;
    const nearToLimitChars = 20;
    const { register, handleSubmit, formState: { errors } } = useForm();    

    const [messageCharsCount, setMessageCharsCount] = useState(0);
    const [classMessageCharsCount, setClassMessageCharsCount] = useState('max-chars');

    const handleCharsCount = nChars => {
        setMessageCharsCount(nChars);
        (nChars > (maxChars - nearToLimitChars)) ? setClassMessageCharsCount('max-chars text-danger') : setClassMessageCharsCount('max-chars');
    }

    const onSubmit = async (data, e) => {
        e.preventDefault();

        if(errors){
            props.onSubmit(data);
        }
    }

    return (
        <Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <section className="row mx-auto px-2 p-md-0 cont-form-postal">
                    <PostalImg idPostal={idPostal} title={title} urlAssets={urlAssets} />
                    <section className="col-12 col-md-6 my-1 bg-form border-form">
                        <CardHeader title={title} urlAssets={urlAssets} urlBrand={urlBrand} />
                        <article className="my-3 text-center">
                            <h3 className="py-1 text-black mail-to">¿A quién se la quieres enviar?</h3>
                        </article>
                        <div className="form-group mt-3 mb-0 px-3 py-1">
                            <label htmlFor="name" className="mail-to text-black">Nombre:</label>
                            <input                     
                                className={`form-control bg-form border-0 border-bottom text-black borde px-0 ${errors.name ? 'is-invalid' : ''}`} 
                                id="name" 
                                name="name"
                                type="text" 
                                {...register("name", { 
                                    required:{
                                        value: true,
                                        message: 'Debes ingresar un nombre' 
                                    }
                                })}
                            />
                            <span className="invalid-feedback text-small d-block mb-2">
                                {errors?.name?.message}
                            </span>
                        </div>
                        <div className="form-group pb-0 pt-1 px-3">
                            <label htmlFor="msg" className="pb-2 mail-to text-black">
                                Texto
                                <span className="max-chars"> (Máximo {maxChars} caracteres),  </span>
                                <span className={classMessageCharsCount}> total: {messageCharsCount}</span>
                            </label>
                            <textarea 
                                className={`form-control bg-form border-0 border-bottom text-black content-msg p-2${errors.msg && 'is-invalid'}`}  
                                id="msg" 
                                name="msg"
                                rows="6"
                                maxLength={maxChars}  
                                onKeyUp={e => {handleCharsCount(e.target.value.length)}}  
                                {...register("msg", { 
                                    required: 'Debes ingresar un texto',
                                    maxLength : {
                                        value: maxChars,
                                        message: `El mensaje no debe exceder de ${maxChars} caracteres`
                                    }
                                })}
                            >
                            </textarea>
                            <span className="invalid-feedback text-small d-block mt-0 mb-3">
                                {errors?.msg?.message}
                            </span>
                        </div>
                        <BrandMail brand={brand} urlBrand={urlBrand} urlPortadaEspeciales={urlPortadaEspeciales} />
                    </section>
                    <section className="d-flex justify-content-center mb-0 mb-md-4 py-3">
                        <button type="submit" className="btn mail-to text-white btn-inicio">Crear tarjeta</button>
                    </section>                            
                </section>
            </form>
        </Fragment>
    )
}

export default AddForm;

AddForm.propTypes = {
    idPostal: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired
}